{
    "META_TITLE": "Avis {realEstateGroup} | {score}/10 - Avis vérifiés HouseMatch",
    "META_DESCRIPTION": "Trouvez le meilleur agent immobilier pour vous en vous basant sur le plus grand nombre d'avis vérifiés en Belgique.",
    "META_TITLE_REVIEW": "{score}/10 pour {realEstateGroup}. Voir tous les avis!"
}